import { RichEditorPlugin } from 'components/editor/types';

import { taskNumberDecorator } from './decorator';

export const createTaskNumberPlugin = (): RichEditorPlugin<'decorator'> => {
  return {
    decorator: [taskNumberDecorator],
  };
};
